import React, {useEffect} from 'react';
import {BrowserRouter, Routes, Route} from "react-router-dom";
// Context
import {ErrorBoundaryProvider, PackagingUiProvider, UserProvider, PackagingDataProvider, ModuleProvider} from "@context";
// Pages
import Main from "@/pages/Main";
import BrandBuilder from "@/pages/BrandBuilder/BrandBuilder";
import RangeBuilder from "@/pages/RangeBuilder/RangeBuilder";
import ProductBuilder from "@/pages/ProductBuilder/ProductBuilder";
import AppBuilder from "@/pages/AppBuilder/AppBuilder";
import FiltersPropagation from "@/pages/FiltersPropagation/FiltersPropagation";
import NotFound from "@/pages/NotFound";
// globals
import 'App.css'
import {PermissionsProvider} from "@/context/PermissionsProvider";
import TourContextProvider from "@/context/TourProvider";
import useVisibleViewportVar from "@/utils/useVisibleViewportVar";

import {parentOrigin} from "./utils/parentOrigin"

function App() {
    // Keep dialogs anchored to the visible area of the iframe (see hook docs).
    useVisibleViewportVar()

    const resize = (size: number) => {
        let payload = JSON.stringify(["resize", size])
        window.top?.postMessage(payload, parentOrigin)
    }

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            resize(entries[0].target.clientHeight)
        })
        resizeObserver.observe(document.body)
        return () => resizeObserver.disconnect()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

  return (
      <>
        <ErrorBoundaryProvider>
            <UserProvider>
                <ModuleProvider>
                    <PermissionsProvider>
                        <PackagingDataProvider>
                            <PackagingUiProvider>
                                <TourContextProvider>
                                    <BrowserRouter>
                                        <Routes>
                                            {/* BRANDS */}
                                            <Route path={"/brands/create"} element={<BrandBuilder creating />} />
                                            <Route path={"/brands/edit"} element={<BrandBuilder editing />} />
                                            {/* RANGES */}
                                            <Route path={"/ranges/create"} element={<RangeBuilder creating />} />
                                            <Route path={"/ranges/edit"} element={<RangeBuilder editing />} />
                                            {/* PRODUCTS*/}
                                            <Route path={"/products/create"} element={<ProductBuilder creating />} />
                                            <Route path={"/products/gs1/create"} element={<ProductBuilder creating gs1 />} />
                                            <Route path={"/products/edit"} element={<ProductBuilder editing />} />
                                            <Route path={"/products/gs1/edit"} element={<ProductBuilder editing gs1 />} />
                                            {/* APPS */}
                                            <Route path={"/apps/edit"} element={<AppBuilder editing />} />
                                            {/* SETTINGS */}
                                            <Route path={"/settings/filters-propagation"} element={<FiltersPropagation />} />
                                            {/* MAIN */}
                                            <Route path={"/"} element={<Main />} />
                                            {/* FALLBACK */}
                                            <Route path={"*"} element={<NotFound />} />
                                        </Routes>
                                    </BrowserRouter>
                                </TourContextProvider>
                            </PackagingUiProvider>
                        </PackagingDataProvider>
                    </PermissionsProvider>
                </ModuleProvider>
            </UserProvider>
        </ErrorBoundaryProvider>
      </>
  );
}

export default App;
